import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Flex } from 'antd';

import { Notification } from 'src/Components';
import { CURRENCIES, currencyTextValue, i18, trb } from 'src/Utilities';
import { OMCActions, OMCConstants } from 'src/Redux';
import { Typography } from 'src/shared';

const maxCheckedRow = 30;
const messagesEndRef = React.createRef();

interface IProps {
  UOLR: any;
  sendUOLR: any;
}

export const UnsignedPaymentsTemporary = ({ UOLR, sendUOLR }: IProps) => {
  const dispatch = useDispatch();
  const { sendATR } = useSelector((state: any) => state.UACReducers);
  const [state, setState] = useState({
    selectedRowKeys: [] as any,
    send: false,
    itemInst: null,
    isError: false,
    isErrorGlobal: false,
    errors: [] as any,
    currentStep: 0,
    approve: false,
    approveInst: false,
    RQ_ID: null,
    selectAllChecked: false,
    AuthType: null,
    Code: null,
    submitting: false,
  });

  const loading = sendUOLR || sendATR || state.send;

  const selectRow = (checked: any, id: any) => {
    if (checked) {
      setState({
        ...state,
        selectedRowKeys: [...state.selectedRowKeys, id] as any,
      });
    } else {
      setState({
        ...state,
        selectedRowKeys: state.selectedRowKeys.filter((e: any) => e !== id),
      });
    }
  };

  const clickDeleteButton = () => {
    const { selectedRowKeys } = state;

    dispatch(OMCActions.postDUOR({ ItemsIDs: selectedRowKeys }) as any).then((response: any) => {
      if (response.type === OMCConstants.POST_OMC_DUOR_SUCCESS) {
        if (response.payload.IsSuccessfull) {
          Notification({
            type: 'success',
            message: trb(i18.MessageTitles.DeletedSuccessUnsignedPaymentsTitle),
            description: trb(i18.Messages.DeletedSuccessUnsignedPaymentsDesc),
          });
          dispatch(OMCActions.postUOLR() as any);
        } else {
          Notification({
            type: 'error',
            message: trb(i18.Messages.ResponseError),
          });
        }
      }
      setState({ ...state, selectedRowKeys: [], errors: [], isError: false });
    });
  };

  const checkCountMore = (disabled = true) => {
    if (disabled) {
      Notification({
        type: 'error',
        message: trb(i18.Messages.NoSignedPaymentErrorMuchMore),
        description: i18.NotificationMessages.NoSignedPaymentErrorMuchMore + `: ${maxCheckedRow}`,
      });
    }
  };

  const checkRow = (e: any, id = null) => {
    const isChecked = e.target.checked;

    selectRow(isChecked, id);
    if (!isChecked) {
      setState((prevState) => ({
        ...prevState,
        selectAllChecked: false,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        selectAllChecked: prevState.selectedRowKeys.length === Math.min(UOLR.Operations.length, maxCheckedRow),
      }));
    }
  };

  const checkAllRow = (e: any) => {
    const isChecked = e.target.checked;

    setState((prevState) => ({
      ...prevState,
      selectedRowKeys: isChecked ? UOLR.Operations.slice(0, maxCheckedRow).map((item: any) => item.ID) : [],
      selectAllChecked: isChecked,
    }));
  };

  const { selectedRowKeys } = state;

  if (!UOLR?.Operations?.length) {
    return null;
  }

  return (
    <>
      <Typography.Title className="eb_fs_16 eb_fw_400">{trb(i18.Labels.UnsignedWithoutVOP)}</Typography.Title>
      <Typography.Paragraph className="eb_fs_13">{trb(i18.Labels.UnsignedWithoutVOPDescription)}</Typography.Paragraph>
      <div className="mb-2 w-100">
        <div className="eb_table_wrapper eb_table_nosigned_payment eb_table_wrapper_bottom_lined mb-2">
          <div
            id="UnsignedPaymentsTable"
            className="eb_table"
          >
            <div className="row eb_table_head d-flex d-md-flex">
              <div className="col-12 col-md-2 px-0 px-md-3 py-1 py-md-2 text-nowrap d-none d-md-block">
                <Checkbox
                  id="UnsignedPaymentsAllCheckboxLG"
                  checked={state.selectAllChecked && selectedRowKeys.length > 0}
                  className="mr-2"
                  disabled={loading}
                  onChange={checkAllRow}
                />
                {trb(i18.Labels.Date)}
              </div>
              <div className="col-1 text-nowrap px-0 d-block d-md-none">
                <Checkbox
                  id="UnsignedPaymentsAllCheckboxMD"
                  checked={state.selectAllChecked && selectedRowKeys.length > 0}
                  className="mr-2"
                  disabled={loading}
                  onChange={checkAllRow}
                />
                {trb(i18.Labels.SelectAll)}
              </div>
              <div className="col-3 d-none d-md-block">{trb(i18.Labels.SenderData)}</div>
              <div className="col-3 d-none d-md-block">{trb(i18.Labels.ReceivedData)}</div>
              <div className="col-2 d-none d-md-block">{trb(i18.Labels.PaymentDescription)}</div>
              <div className="col-2 text-right d-none d-md-block">{trb(i18.Labels.Amount)}</div>
            </div>
            {UOLR.Operations?.map((item: any, index: any) => {
              const disabled = selectedRowKeys.length === maxCheckedRow && !selectedRowKeys.includes(item?.ID);

              return (
                <React.Fragment key={index}>
                  <div
                    id={`UnsignedPaymentsTR${index}`}
                    className="row eb_table_row text-word-wrap py-1 py-md-0 overflow-hidden"
                  >
                    <div
                      className="col-12 col-md-2 px-0 px-md-3 py-1 py-md-2 text-nowrap"
                      onClick={() => checkCountMore(disabled)}
                    >
                      <div className="row">
                        <div className="d-none d-md-block col-1 col-md-12 mb-2">
                          <Checkbox
                            id={`UnsignedPaymentsTR${index}CheckboxLG`}
                            checked={selectedRowKeys.includes(item?.ID)}
                            className="mr-2"
                            disabled={loading || disabled}
                            onChange={(e) => checkRow(e, item.ID)}
                          />
                          {item.DateFormatted}
                        </div>
                        <div
                          style={{ position: 'relative', left: 15 }}
                          className="d-block d-md-none col-1 col-md-12 mb-2 px-0"
                        >
                          <Checkbox
                            id={`UnsignedPaymentsTR${index}CheckboxMD`}
                            checked={selectedRowKeys.includes(item.ID)}
                            disabled={loading || disabled}
                            onChange={(e) => checkRow(e, item.ID)}
                          />
                        </div>
                        <div className="col-4 mb-2 text-black-50 d-md-none">{trb(i18.Labels.Date)}</div>
                        <div className="col-7 d-md-none mb-2">
                          <span className="eb_fw_300 unassigned-payments-right-value">{item.DateFormatted}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 px-0 px-md-3 py-1 py-md-2">
                      <div className="row">
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-11 mb-2 d-block d-md-none text-black-50">{trb(i18.Labels.SenderData)}</div>
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-11 col-md-12 mb-2">
                          <div>{item.SenderName}</div>
                          <div className="eb_fw_300">{item.SenderAccount}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 px-0 px-md-3 py-1 py-md-2">
                      <div className="row">
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-11 mb-2 d-block d-md-none text-black-50">{trb(i18.Labels.ReceivedData)}</div>
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-11 col-md-12 mb-2">
                          <div>{item.ReceiverName}</div>
                          <div className="eb_fw_300">{item.ReceiverAccount}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-2 px-0 px-md-3 py-1 py-md-2">
                      <div className="row">
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-11 mb-2 d-block d-md-none text-black-50">{trb(i18.Labels.PaymentDescription)}</div>
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-11 col-md-12 mb-2">
                          <div>{item.Description}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-2 px-0 px-md-3 py-1 py-md-2 text-right">
                      <div className="row text-start text-md-end">
                        <div className="col-1 mb-2 d-md-none px-0" />
                        <div className="col-4 mb-2 d-block d-md-none text-black-50">{trb(i18.Labels.Amount)}</div>
                        <div className="col-7 col-md-12 text-nowrap text-primary eb_fw_600">
                          <div className="unassigned-payments-right-value">{currencyTextValue(item.Amount[0].Value, item.Amount[0].Currency || CURRENCIES.EUR)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
      <Flex
        ref={messagesEndRef as any}
        justify="end"
        gap="small"
        wrap="wrap"
        className="mb-2"
      >
        <Button
          id="UnsignedPaymentsDeleteButton"
          onClick={clickDeleteButton}
          disabled={selectedRowKeys.length <= 0 || loading}
          className="col-12 col-md-auto"
          size="large"
        >
          {trb(i18.Buttons.DeleteSelectedPayments)}
        </Button>
      </Flex>
    </>
  );
};
